import React from 'react';
import { Star, Quote } from 'lucide-react';
import { TESTIMONIALS } from '../../constants/site';

const FiveStars = ({ className }) => (
  <div className="flex space-x-1">
    {[0, 1, 2, 3, 4].map((i) => <Star key={i} className={className} />)}
  </div>
);

const TestimonialCard = ({ t }) => (
  <div className="group bg-white/95 backdrop-blur-md rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 border-2 border-blue-100/50 hover:border-blue-300/50 relative overflow-hidden">
    <div className="absolute top-0 right-0 w-20 h-20 gold-gradient opacity-10 rounded-bl-full"></div>
    <div className="absolute -top-3 -left-3 w-14 h-14 bg-gradient-to-br from-blue-400 to-cyan-400 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
      <Quote className="w-7 h-7 text-white" />
    </div>
    <div className="space-y-4 mt-6">
      <FiveStars className="w-5 h-5 fill-gold-400 text-gold-400" />
      <p className="text-gray-700 leading-relaxed text-base">"{t.text}"</p>
      <div className="pt-4 border-t-2 border-blue-100 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-cyan-400 rounded-full flex items-center justify-center font-bold text-white shadow-md">{t.initials}</div>
          <div>
            <div className="font-bold text-gray-900">{t.name}</div>
            <div className="text-sm text-gray-500">{t.time}</div>
          </div>
        </div>
        <div className="text-xs font-semibold text-blue-600 bg-blue-50 px-3 py-1 rounded-full">{t.badge}</div>
      </div>
    </div>
  </div>
);

export const TestimonialsSection = () => (
  <section id="reviews" className="py-16 sm:py-24 bg-gradient-to-br from-gray-50 to-blue-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-3xl mx-auto mb-16 space-y-6">
        <div className="inline-flex items-center space-x-3 px-6 py-3 bg-sand-50 border-2 border-blue-200/60 rounded-full shadow-lg">
          <Star className="w-5 h-5 text-gold-400 fill-gold-400" />
          <span className="text-sm font-bold text-gray-700 tracking-wide uppercase">Client Reviews</span>
        </div>
        <h2 className="text-5xl sm:text-6xl font-serif font-bold leading-tight">What My<span className="block gold-gradient-text">Clients Say</span></h2>
        <div className="flex items-center justify-center space-x-6">
          <div className="flex items-center space-x-2">
            <span className="text-5xl font-black text-gray-900">5.0</span>
            <FiveStars className="w-6 h-6 fill-gold-400 text-gold-400" />
          </div>
          <div className="text-left border-l-2 border-gray-200 pl-4">
            <div className="text-sm font-semibold text-gray-600">Based on</div>
            <div className="text-lg font-bold text-gray-900">Verified Reviews</div>
          </div>
        </div>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {TESTIMONIALS.map((t) => <TestimonialCard key={t.name} t={t} />)}
      </div>
      <div className="text-center mt-12">
        <p className="text-gray-600 mb-4 font-medium">Worked with me? I'd love your feedback!</p>
        <a href="https://www.google.com/search?q=jessica+burnette+realtor" target="_blank" rel="noopener noreferrer" className="inline-flex items-center space-x-2 px-8 py-4 gold-gradient text-white rounded-xl shadow-xl hover:shadow-2xl transition-all font-bold">
          <Star className="w-5 h-5" /><span>Leave a Google Review</span>
        </a>
      </div>
    </div>
  </section>
);
